/**
 * Note: these values are only currently correct for desktop and should not be used on ODD.
 */

// Valid for most typography styles
export const fontFamily = 'Public Sans'

export const fontWeightRegular = '400'
export const fontWeightSemiBold = '600'
export const fontWeightBold = '700'

// Display styles
const fontFamilyDisplay = fontFamily
const fontSizeDisplay = '2.4375rem' // 39px
const lineHeightDisplay = '3rem' // 48px

// Display-Bold
export const fontSizeDisplayBold = fontSizeDisplay
export const lineHeightDisplayBold = lineHeightDisplay
export const fontFamilyDisplayBold = fontFamilyDisplay
export const fontWeightDisplayBold = fontWeightBold
export const fontStyleDisplayBold = `${fontWeightDisplayBold} ${fontSizeDisplayBold}/${lineHeightDisplayBold} ${fontFamilyDisplayBold}`

// Heading-Large
const fontSizeHeadingLarge = '1.625rem' // 26px
const lineHeightHeadingLarge = '2rem' // 32px
const fontFamilyHeadingLarge = fontFamily

// Heading-Large-Regular
export const fontFamilyHeadingLargeRegular = fontFamilyHeadingLarge
export const fontSizeHeadingLargeRegular = fontSizeHeadingLarge
export const lineHeightHeadingLargeRegular = lineHeightHeadingLarge
export const fontWeightHeadingLargeRegular = fontWeightRegular
export const fontStyleHeadingLargeRegular = `${fontWeightHeadingLargeRegular} ${fontSizeHeadingLargeRegular}/${lineHeightHeadingLargeRegular} ${fontFamilyHeadingLargeRegular}`

// Heading-Large-Bold
export const fontFamilyHeadingLargeBold = fontFamilyHeadingLarge
export const fontSizeHeadingLargeBold = fontSizeHeadingLarge
export const lineHeightHeadingLargeBold = lineHeightHeadingLarge
export const fontWeightHeadingLargeBold = fontWeightBold
export const fontStyleHeadingLargeBold = `${fontWeightHeadingLargeBold} ${fontSizeHeadingLargeBold}/${lineHeightHeadingLargeBold} ${fontFamilyHeadingLargeBold}`

// Heading-Medium
const fontSizeHeadingMedium = '1.4375rem' // 23px
const lineHeightHeadingMedium = '1.75rem' // 28px
const fontFamilyHeadingMedium = fontFamily

// Heading-Medium-Regular
export const fontSizeHeadingMediumSemiBold = fontSizeHeadingMedium
export const lineHeightHeadingMediumSemiBold = lineHeightHeadingMedium

export const fontFamilyHeadingMediumSemiBold = fontFamilyHeadingMedium
export const fontWeightHeadingMediumSemiBold = fontWeightSemiBold
export const fontStyleHeadingMediumSemiBold = `${fontWeightHeadingMediumSemiBold} ${fontSizeHeadingMediumSemiBold}/${lineHeightHeadingMediumSemiBold} ${fontFamilyHeadingMediumSemiBold}`
export const fontStyleHeadingMediumBold = `${fontWeightBold} ${fontSizeHeadingMedium}/${lineHeightHeadingMediumSemiBold} ${fontFamilyHeadingMediumSemiBold}`

// Heading-Small
const fontSizeHeadingSmall = '1.125rem' // 18px
const lineHeightHeadingSmall = '1.5rem' // 24px
const fontFamilyHeadingSmall = fontFamily

// Heading-Small-Regular
export const fontSizeHeadingSmallRegular = fontSizeHeadingSmall
export const lineHeightHeadingSmallRegular = lineHeightHeadingSmall
export const fontFamilyHeadingSmallRegular = fontFamilyHeadingSmall
export const fontWeightHeadingSmallRegular = '400'
export const fontStyleHeadingSmallRegular = `${fontWeightHeadingSmallRegular} ${fontSizeHeadingSmallRegular}/${lineHeightHeadingSmallRegular} ${fontFamilyHeadingSmallRegular}`

// Heading-Small-Bold
export const fontSizeHeadingSmallBold = fontSizeHeadingSmall
export const lineHeightHeadingSmallBold = lineHeightHeadingSmall
export const fontFamilyHeadingSmallBold = fontFamilyHeadingSmall
export const fontWeightHeadingSmallBold = fontWeightBold
export const fontStyleHeadingSmallBold = `${fontWeightHeadingSmallBold} ${fontSizeHeadingSmallBold}/${lineHeightHeadingSmallBold} ${fontFamilyHeadingSmallBold}`
export const fontStyleHeadingSmallSemiBold = `${fontWeightSemiBold} ${fontSizeHeadingSmallBold}/${lineHeightHeadingSmallBold} ${fontFamilyHeadingSmallBold}`

// Body-Large
const fontSizeBodyLarge = '1rem' // 16px
const lineHeightBodyLarge = '1.5rem' // 24px
const fontFamilyBodyLarge = fontFamily

// Body-Large-Medium
export const fontSizeBodyLargeSemiBold = fontSizeBodyLarge
export const lineHeightBodyLargeSemiBold = lineHeightBodyLarge
export const fontFamilyBodyLargeSemiBold = fontFamilyBodyLarge
export const fontWeightBodyLargeSemiBold = fontWeightSemiBold
export const fontStyleBodyLargeSemiBold = `${fontWeightBodyLargeSemiBold} ${fontSizeBodyLargeSemiBold}/${lineHeightBodyLargeSemiBold} ${fontFamilyBodyLargeSemiBold}`

// Body-Large-Regular
export const fontSizeBodyLargeRegular = fontSizeBodyLarge
export const lineHeightBodyLargeRegular = lineHeightBodyLarge
export const fontFamilyBodyLargeRegular = fontFamilyBodyLarge
export const fontWeightBodyLargeRegular = fontWeightRegular
export const fontStyleBodyLargeRegular = `${fontWeightBodyLargeRegular} ${fontSizeBodyLargeRegular}/${lineHeightBodyLargeRegular} ${fontFamilyBodyLargeRegular}`

// Body-Default
const fontSizeBodyDefault = '0.875rem' // 14px
const lineHeightBodyDefault = '1.25rem' // 20px
const fontFamilyBodyDefault = fontFamily

// Body-Default-Medium
export const fontSizeBodyDefaultSemiBold = fontSizeBodyDefault
export const lineHeightBodyDefaultSemiBold = lineHeightBodyDefault
export const fontFamilyBodyDefaultSemiBold = fontFamilyBodyDefault
export const fontWeightBodyDefaultSemiBold = fontWeightSemiBold
export const fontStyleBodyDefaultSemiBold = `${fontWeightBodyDefaultSemiBold} ${fontSizeBodyDefaultSemiBold}/${lineHeightBodyDefaultSemiBold} ${fontFamilyBodyDefaultSemiBold}`

// Body-Default-Regular
export const fontSizeBodyDefaultRegular = fontSizeBodyDefault
export const lineHeightBodyDefaultRegular = lineHeightBodyDefault
export const fontFamilyBodyDefaultRegular = fontFamilyBodyDefault
export const fontWeightBodyDefaultRegular = fontWeightRegular
export const fontStyleBodyDefaultRegular = `${fontWeightBodyDefaultRegular} ${fontSizeBodyDefaultRegular}/${lineHeightBodyDefaultRegular} ${fontFamilyBodyDefaultRegular}`

// Caption
const fontSizeCaption = '0.8125rem' // 13px
const lineHeightCaption = '1rem' // 16px
const fontFamilyCaption = fontFamily

// Caption-Bold
export const fontSizeCaptionBold = fontSizeCaption
export const lineHeightCaptionBold = lineHeightCaption
export const fontFamilyCaptionBold = fontFamilyCaption
export const fontWeightCaptionBold = fontWeightBold
export const fontStyleCaptionBold = `${fontWeightCaptionBold} ${fontSizeCaptionBold}/${lineHeightCaptionBold} ${fontFamilyCaptionBold}`

// Caption-Medium
export const fontSizeCaptionSemiBold = fontSizeCaption
export const lineHeightCaptionSemiBold = lineHeightCaption
export const fontFamilyCaptionSemiBold = fontFamilyCaption
export const fontWeightCaptionSemiBold = fontWeightSemiBold
export const fontStyleCaptionSemiBold = `${fontWeightCaptionSemiBold} ${fontSizeCaptionSemiBold}/${lineHeightCaptionSemiBold} ${fontFamilyCaptionSemiBold}`

// Caption-Regular
export const fontSizeCaptionRegular = fontSizeCaption
export const lineHeightCaptionRegular = lineHeightCaption
export const fontFamilyCaptionRegular = fontFamilyCaption
export const fontWeightCaptionRegular = fontWeightRegular
export const fontStyleCaptionRegular = `${fontWeightCaptionRegular} ${fontSizeCaptionRegular}/${lineHeightCaptionRegular} ${fontFamilyCaptionRegular}`

// Code
const fontSizeCode = '0.8125rem' // 12px
const lineHeightCode = '1.25rem' // 20px
const fontFamilyCode = 'Reddit Mono'

// Code-Regular
export const fontSizeCodeRegular = fontSizeCode
export const lineHeightCodeRegular = lineHeightCode
export const fontFamilyCodeRegular = fontFamilyCode
export const fontWeightCodeRegular = fontWeightRegular
export const fontStyleCodeRegular = `${fontWeightCodeRegular} ${fontSizeCodeRegular}/${lineHeightCodeRegular} ${fontFamilyCodeRegular}`
